import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Globe2, ArrowUpRight } from 'lucide-react';
import { EXPORT_PAGES } from '../lib/pageContent';
import { EXPORT_CTA } from '../constants/testIds';
import { CountryFlag } from './CountryFlag';

const PUBLISHED_COUNTRIES = EXPORT_PAGES.filter((p) => p.type === 'country' && !p.draft);

export const ExportCTA = () => (
  <section data-testid={EXPORT_CTA.section} className="relative bg-brand-surface py-20 sm:py-24 border-y border-brand-border/60 overflow-hidden">
    <div className="absolute -right-24 -top-24 w-80 h-80 rounded-full bg-brand-amber/10 blur-3xl pointer-events-none" />
    <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="flex flex-col lg:flex-row lg:items-center justify-between gap-10"
      >
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-brand-amber bg-brand-bg/60 border border-brand-border rounded-full px-4 py-1.5 mb-5">
            <Globe2 className="w-3.5 h-3.5" />
            Export Destinations
          </span>
          <h2 className="font-display font-extrabold uppercase tracking-tight text-brand-text text-3xl sm:text-4xl lg:text-5xl">
            See Every Port We Ship To
          </h2>
          <p className="mt-5 text-brand-muted text-base sm:text-lg">
            Compliance guidance, grades and shipping options for each market we currently export bulk used tires
            to — browse the full Export Hub before you request a quote.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            {PUBLISHED_COUNTRIES.map((p) => (
              <Link
                key={p.slug}
                to={`/export/${p.slug}`}
                className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-wider text-brand-text border border-brand-border rounded-full px-4 py-1.5 bg-brand-bg/60 hover:border-brand-orange hover:text-brand-orange transition-colors"
              >
                <CountryFlag code={p.countryCode} />
                {p.navLabel}
              </Link>
            ))}
          </div>

          <div className="mt-9">
            <Link
              to="/export"
              data-testid={EXPORT_CTA.ctaButton}
              className="inline-flex items-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3.5 transition-colors"
            >
              View All Export Destinations
              <ArrowUpRight className="w-4 h-4" />
            </Link>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
          className="shrink-0 w-full max-w-xs lg:w-72 aspect-square rounded-full border border-brand-border/70 bg-brand-bg flex items-center justify-center mx-auto"
        >
          <Globe2 className="w-24 h-24 text-brand-amber/50" strokeWidth={1} />
        </motion.div>
      </motion.div>
    </div>
  </section>
);
